module.exports = __webpack_public_path__ + "files/592cc4ab32f9e8b7072c2389596d72a8.png";